var _polygon, _path, _line, _line2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.91,
    strokeMiterlimit: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "22.5 22.5 1.5 22.5 1.5 20.59 2.46 18.68 21.55 18.68 22.5 20.59 22.5 22.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75,5.32h.49a9.3,9.3,0,0,1,9.3,9.3v.25a0,0,0,0,1,0,0H2.45a0,0,0,0,1,0,0v-.25A9.3,9.3,0,0,1,11.75,5.32Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1.5,
    x2: 12,
    y2: 5.32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.14,
    y1: 1.5,
    x2: 14.86,
    y2: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.32,
    y: 14.86,
    width: 13.36,
    height: 3.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBell);
export default __webpack_public_path__ + "static/media/service-bell.56c5098ac4ce68e61b392bfd08f147e8.svg";
export { ForwardRef as ReactComponent };